export default __webpack_public_path__ + "static/media/WindowsTaskScheduler-TriggerDailyTimeSetting03.3bffa040.png";